var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapsible"},[(_vm.hasHeader)?_c('header',{on:{"click":_vm.toggle}},[_vm._t("header")],2):_vm._e(),_c('div',{ref:"content",staticClass:"collapsible-content",class:{ active: _vm.isOpenInternal }},[_c('div',{ref:"inner",staticClass:"collapsible-inner"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }